import { Skeleton } from 'common/components/Skeleton/Skeleton'

export function PostSkeleton() {
  return (
    <div className='relative flex flex-col rounded-2xl bg-white mb-3 overflow-hidden'>
      <div className='flex flex-1 p-6 pb-8'>
        <div className='flex flex-col flex-1 min-w-0'>
          <div className='flex items-center mb-6'>
            <Skeleton className='!w-10 !h-10 shrink-0 rounded-full' />
            <div className='ml-3'>
              <Skeleton className='w-32' />
              <Skeleton className='w-20 mt-2' />
            </div>
          </div>
          <Skeleton className='w-full' />
          <Skeleton className='w-3/5 mt-2' />
        </div>
      </div>
    </div>
  )
}
